import { Box, Button, Text } from '@domain-group/suit-theme'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowUpRightFromSquare } from '@fortawesome/pro-light-svg-icons'

import type { UseOrderItemPayload } from '@hooks/useOrderItem'
import type { UseCampaignQuoteItemPayload } from '@hooks/useCampaignQuoteItem'

interface ExternalManagementProps {
  boxProps?: object,
  itemPayload: UseOrderItemPayload | UseCampaignQuoteItemPayload,
}

const ExternalManagement = (props: ExternalManagementProps) => {
  const {
    boxProps,
    itemPayload: {
      // @ts-expect-error TS2339
      orderItem: {
        deep_link,
        deep_link_url,
      },
      // @ts-expect-error TS2339
      provider,
    },
  } = props

  return (
    <Box
      alignItems="center"
      backgroundColor="white"
      borderRadius={5}
      border="1px dashed"
      borderColor="lineColor"
      justifyContent="space-between"
      padding="large"
      {...boxProps}
    >
      <Text
        color="bodyFontLightColor"
        fontSize="xsmall"
      >
        Manage in {provider?.title || 'External System'}
      </Text>

      <Button
        // @ts-expect-error TS2322
        as="a"
        buttonStyle="secondaryCreate"
        href={deep_link_url}
        icon={<FontAwesomeIcon icon={faArrowUpRightFromSquare} />}
        rel="noopener noreferrer"
        target="_blank"
        size="small"
        width="auto"
      >
        {deep_link?.link_text || 'Manage Item'}
      </Button>
    </Box>
  )
}

export default ExternalManagement
